import React, { useState } from "react";
import { connect } from "react-redux";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import Typography from "@mui/material/Typography";
import mobileBottom from "assets/images/mobile-bottom-curve.svg";
import ShareHCPApp from "pages/home/ShareHCPApp";

const MainText = (props) => {
  const { organizationInfo, headingOne } = props;
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const matchesLg = useMediaQuery(theme.breakpoints.down("lg"));
  const matchesXL = useMediaQuery(theme.breakpoints.down("xl"));
  const matchesWidth = useMediaQuery("(max-width:600px)");
  const matchesSmallestWidth = useMediaQuery("(max-width:320px)");
  const matchesminWidth = useMediaQuery("(max-width:350px)");
 
  const isHCPTemplate =
    organizationInfo?.type?.toLowerCase() === "h" &&
    organizationInfo?.app?.appCode?.toLowerCase() == "hcp";

  const isShowBackgroundAssets =
    organizationInfo?.organizationOptionJson?.showBackgroundAssetsFlag?.toUpperCase() ===
    "Y";

  const isPOSTemplate =
    organizationInfo?.type?.toLowerCase() === "p" &&
    organizationInfo?.app?.appCode?.toLowerCase() == "hcp";
  

  const [showSharePopup, setShowSharePopup] = useState(false);
  const widgetEnabled = sessionStorage.getItem("widgetEnabled");

  return (
    <>
      {widgetEnabled?.toLowerCase() === "n" && (
        <>
          {isShowBackgroundAssets && (
            <>
              <Box sx={{ display: matches ? "block" : "none" }}>
                <img
                  src={mobileBottom}
                  alt="mabile-arc"
                  className="mobile-bottom-arc"
                  style={{ transform: "rotate(180deg)" }}
                />
              </Box>
              {organizationInfo.app?.appCode === "CVD" && (
                <Box
                  style={{
                    textAlign: "center",
                    paddingTop: matches ? "15px" : undefined,
                  }}
                >
                  <Typography
                    variant="h1LatoBlack"
                    sx={{
                      fontSize: matchesWidth
                        ? "20px"
                        : matchesXL
                        ? "36px"
                        : "44px",
                      lineHeight: matchesWidth ? "0px" : "55px",
                      color: "#093d4c",
                      letterSpacing: "0.95px",
                    }}
                  >
                    {headingOne || (
                      <>
                        Get that Cuverd
                        <sup style={{ fontSize: "18px" }}>®</sup> feeling
                      </>
                    )}
                  </Typography>
                </Box>
              )}
            </>
          )}
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: matchesLg ? undefined : "600px",
                marginTop: matches ? "0px" : "5px",
                position: matches ? "relative" : undefined,
                minHeight: matches ? "130px" : "150px",
                marginBottom: matches ? "20px" : "32px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {isHCPTemplate ? (
                <Box>
                  <Box
                    sx={{
                      height: "100%",
                      textAlign: "center",
                      paddingBottom: "2%",
                      paddingTop: "2%",
                    }}
                  >
                    <Typography
                      variant={"h4LatoHeavy"}
                      sx={{
                        color: `${organizationInfo?.colorSchemeJson?.stepsTextColor}`,
                        letterSpacing: matchesWidth ? "0px" : "0.6px",
                        lineHeight: matchesSmallestWidth ? undefined : "24px",
                        fontSize: matchesminWidth
                          ? "13px"
                          : matchesWidth
                          ? "22px"
                          : "26px",
                      }}
                      dangerouslySetInnerHTML={{
                        __html:
                          organizationInfo?.organizationOptionJson
                            ?.appDescription,
                      }}
                    ></Typography>
                  </Box>
                  {organizationInfo?.organizationOptionJson?.appStepText &&
                    organizationInfo?.organizationOptionJson?.appStepText
                      ?.length > 0 && (
                      <Grid
                        container
                        sx={{ display: "grid", justifyContent: "center" }}
                        spacing={0}
                        columns={16}
                      >
                        {organizationInfo?.organizationOptionJson?.appStepText?.map(
                          (item, index) => (
                            <Grid
                              key={"list_" + index}
                              item
                              sx={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <CheckIcon
                                sx={{
                                  color: `${organizationInfo?.colorSchemeJson?.stepsTextColor}`,
                                }}
                              />
                              <Typography
                                variant={"h3LatoMedium"}
                                sx={{
                                  color: `${organizationInfo?.colorSchemeJson?.stepsTextColor}`,
                                  letterSpacing: matchesWidth ? "0px" : "0.6px",
                                  lineHeight: matchesSmallestWidth
                                    ? undefined
                                    : "24px",
                                  fontSize: matchesminWidth
                                    ? "9px"
                                    : matchesWidth
                                    ? "14px"
                                    : "16px",
                                }}
                              >
                                {item}
                              </Typography>
                            </Grid>
                          )
                        )}
                      </Grid>
                    )}
                </Box>
              ) : isPOSTemplate ? (
                <Box sx={{ height: "100%", textAlign: "center" }}>
                  <Typography
                    variant={matches ? "h3LatoMedium" : "h1LatoSemiBold"}
                    sx={{
                      color: "#093d4c",
                      letterSpacing: matchesWidth ? "0px" : "0.6px",
                      lineHeight: matchesSmallestWidth ? undefined : "24px",
                      fontSize: matchesminWidth
                        ? "11px"
                        : matchesWidth
                        ? "14px"
                        : "20px",
                    }}
                    dangerouslySetInnerHTML={{
                      __html:
                        organizationInfo?.organizationOptionJson
                          ?.appDescription,
                    }}
                  ></Typography>
                </Box>
              ) : (
                <Box>
                  <Box
                    sx={{
                      height: "100%",
                      textAlign: "center",
                      padding: matches ? "5px 10px 15px 10px" : "10px",
                    }}
                  >
                    <Typography
                      variant={matches ? "h3LatoMedium" : "h1LatoSemiBold"}
                      sx={{
                        color: "#093d4c",
                        letterSpacing: matchesWidth ? "0.2px" : "0.6px",
                        lineHeight: matches ? "12px" : "24px",
                        fontSize: matchesminWidth
                          ? "11px"
                          : matches
                          ? "15px"
                          : "22px",
                      }}
                      dangerouslySetInnerHTML={{
                        __html:
                          organizationInfo?.organizationOptionJson
                            ?.appDescription,
                      }}
                    ></Typography>
                  </Box>
                  {organizationInfo?.organizationOptionJson?.appStepText &&
                    organizationInfo?.organizationOptionJson?.appStepText
                      ?.length > 0 && (
                      <Grid
                        sx={{
                          marginTop: matches ? "-15px" : "-10px",
                          padding: "0px 20px 0px 20px",
                        }}
                        container
                        spacing={2}
                        columns={16}
                      >
                        {organizationInfo?.organizationOptionJson?.appStepText?.map(
                          (item, index) => (
                            <Grid
                              key={"list_" + index}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                paddingLeft:
                                  index % 2 === 0 ? "auto" : "0px !important",
                                paddingTop: matches
                                  ? "4px !important"
                                  : "16px !important",
                              }}
                              item
                              xs={8}
                            >
                              <div
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  border: `solid 1px ${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor}`,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  display: "flex",
                                  backgroundColor: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor}`,
                                  borderRadius: "50%",
                                  color: "#fff",
                                  marginRight: matches ? "5px" : "10px",
                                }}
                              >
                                <Typography
                                  variant={"footerText"}
                                  sx={{
                                    width: "30px",
                                    height: "30px",
                                    border: `solid 1px ${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor}`,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    display: "flex",
                                    backgroundColor: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.backgroundColor}`,
                                    borderRadius: "50%",
                                    color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                                    fontSize: matchesminWidth
                                      ? "11px"
                                      : matchesWidth
                                      ? "12px"
                                      : "18px",
                                  }}
                                >
                                  {index + 1}
                                </Typography>
                              </div>

                              <Typography
                                variant={matches ? "footerText" : "footerText"}
                                sx={{
                                  textAlign: "left",
                                  color: `${
                                    organizationInfo?.colorSchemeJson
                                      ?.stepsTextColor || "#093d4c"
                                  }`,
                                  letterSpacing: matchesWidth
                                    ? "0.2px"
                                    : "0.6px",
                                  lineHeight: matchesSmallestWidth
                                    ? undefined
                                    : "20px",
                                  fontSize: matchesminWidth
                                    ? "11px"
                                    : matchesWidth
                                    ? "12px"
                                    : "18px",
                                  fontWeight: "bold",
                                }}
                              >
                                {item}
                              </Typography>
                            </Grid>
                          )
                        )}
                      </Grid>
                    )}
                </Box>
              )}
            </Box>
          </Box>
        </>
      )}
      {showSharePopup && (
        <ShareHCPApp
          setShowSharePopup={setShowSharePopup}
          shareCoupon={false}
          shareApp={showSharePopup}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    organizationInfo: state.organizationInfo.data,
  };
};

export default connect(mapStateToProps)(MainText);
